import { UsersAction } from './users.actions';
import { RegistrationScenarioSettings } from '../../models/registration-scenario-settings/registration-scenario-settings.model';


export class UsersState {
    public currentUser: any;
    public pending: boolean;
    public logoutInProgress: boolean;
    public error: null;
    public authenticationFailedCount: number;
    public accounts: any[];
    public isUserLogin: boolean;
    public sendingEmail: boolean;
    public loginAttempt: any;
    public sessionID: any;
    public platform: RegistrationScenarioSettings;
    public realtimeToken: string;
    public cblcArray: any[];
}

export const initialState: UsersState = {
    currentUser: null,
    pending: false,
    logoutInProgress: false,
    error: null,
    authenticationFailedCount: 4,
    accounts: [],
    sendingEmail: false,
    loginAttempt: {},
    sessionID: null,
    platform: null,
    isUserLogin: false,
    realtimeToken: null,
    cblcArray: []
};

export function UsersReducer(state = initialState, { type, payload }) {

    switch (type) {
        case UsersAction.login:
        case UsersAction.authenticateUserUsingToken:
        case UsersAction.authenticateUserUsingTokenFromWebApp:
            return { ...state, ...{ pending: true, error: null } };
        case UsersAction.authenticateUserUsingTokenFromRegister:
            return { ...state, ...{ pending: true, error: null } };

        case UsersAction.loginSuccess:
            return { ...state, ...{ currentUser: payload, authenticationFailedCount: 0, pending: false } };

        case UsersAction.loginCancel:
            return { ...state, ...{ pending: false } };

        case UsersAction.loginDenied:
            return { ...state, ...{ error: payload.message, authenticationFailedCount: payload.authenticationFailedCount, pending: false } };

        case UsersAction.loginError:
            return { ...state, ...{ error: payload, pending: false, accounts: [] } };

        case UsersAction.loginRiskBlocked:
            return { ...state, ...{ pending: false } };

        case UsersAction.requestUpdatedCblcSuccess:
            return { ...state, currentUser: { ...(state.currentUser || {}), cblc: payload } };

        // logout
        case UsersAction.logout:
            return { ...state, ...{ logoutInProgress: true } };

        case UsersAction.resetCurrentUser:
            return { ...state, ...{ currentUser: null } };

        case UsersAction.logoutSuccess:
            return { ...state, ...{ logoutInProgress: false } };

        case UsersAction.logoutError:
            return { ...state, ...{ logoutInProgress: false } };

        // alteraçao de senha
        case UsersAction.changePassword:
            return { ...state, ...{ pending: true, error: null } };

        case UsersAction.changePasswordSucess:
            return { ...state, ...{ pending: false, error: null } };

        case UsersAction.changePasswordError:
            return { ...state, ...{ pending: false, error: payload } };

        case UsersAction.accountSelectRequired:
            return { ...state, ...{ accounts: payload, pending: false } };

        // enviar e-mail sobre esqueci minha senha
        case UsersAction.sendForgotPasswordEmail:
            return { ...state, ...{ sendingEmail: true } };

        case UsersAction.forgotPasswordEmailSendingError:
            return { ...state, ...{ sendingEmail: false } };

        case UsersAction.forgotPasswordEmailSuccefulySent:
            return { ...state, ...{ sendingEmail: false } };

        // tentativa de login
        case UsersAction.loginAttempt:
            return { ...state, ...{ loginAttempt: { ...state.loginAttempt, ...payload } } };

        // token necessário
        case UsersAction.tokenRequired:
            return { ...state, ...{ pending: false } };
        // reset error data
        case UsersAction.resetErrorData:
            return { ...state, ...{ error: null } };

        // requisitar e-mail de desbloqueio
        case UsersAction.requestUnlockAccountEmail:
            return { ...state, ...{ pending: true } };
        case UsersAction.requestUnlockAccountEmailError:
            return { ...state, ...{ pending: false, error: payload } };
        case UsersAction.requestUnlockAccountEmailSuccess:
            return { ...state, ...{ pending: false } };
        
        // obtém o ticket para authenticar no HB clássico
        case UsersAction.getTicket:
            return { ...state, ...{ pending: true } };
        case UsersAction.getTicketError:
            return { ...state, ...{ pending: false, error: payload } };
        case UsersAction.getTicketSuccess:
            return { ...state, pending: false, currentUser: { ...(state.currentUser ?? {}), ticket: payload } }

        // desbloquear conta
        case UsersAction.unlockAccount:
            return { ...state, ...{ pending: true } };
        case UsersAction.unlockAccountError:
            return { ...state, ...{ pending: false, error: null } };
        case UsersAction.unlockAccountSuccess:
            return { ...state, ...{ pending: false } };
        case UsersAction.secondFactorNeddedToUnlockAccount:
            return { ...state, ...{ pending: false } };

        // desbloquear conta
        case UsersAction.getLastModifiedPasswordDate:
            return { ...state, ...{ pending: true } };
        case UsersAction.getLastModifiedPasswordDateSucess:
            return { ...state, ...{ pending: false, currentUser: { ...state.currentUser, ...{ lastModifyPassword: payload } } } };
        case UsersAction.getLastModifiedPasswordDateError:
            return { ...state, ...{ pending: false } };

        // TOTP ativo (app)
        case UsersAction.getHasDevice:
            return { ...state, ...{ pending: true } };
        case UsersAction.getHasDeviceSuccess:
            return { ...state, ...{ pending: false, currentUser: { ...state.currentUser, ...{ hasDevice: payload } } } };
        case UsersAction.getHasDeviceError:
            return { ...state, ...{ pending: false } };

        case UsersAction.getSessionID:
            return { ...state, ...{ pending: true } };
        case UsersAction.getSessionIDSuccess:
            return { ...state, ...{ pending: false, sessionID: payload } };
        case UsersAction.getSessionIDError:
            return { ...state, ...{ pending: false } };

        case UsersAction.saveSessionID:
            return { ...state, ...{ pending: false, sessionID: payload } };

        case UsersAction.setCurrentUserByToken:
            return { ...state, ...{ currentUser: payload } };

        case UsersAction.isUserLogin:
            return { ...state, ...{ pending: false, isUserLogin: payload } };

        // origem da plataforma
        case UsersAction.setPlatform:
            return { ...state, ...{ platform: payload } };

        case UsersAction.realtimeTokenReceivedSuccess:
            return { ...state, ...{ realtimeToken: payload } };

        case UsersAction.getUserCblcArraySuccess:
            return { ...state, ...{ cblcArray: payload } };

        default:
            return state;
    }
}
